import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

export const onDatalayerSocialShare = ({ target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }
  const { linkUrl, method, linkText, type } = target;
  const url = new URL(linkUrl);

  return {
    event: 'trackEvent-share',
    event_name: 'share',
    position: 'customer_story',
    content_type: 'customer story',
    link_text: linkText,
    link_url: linkUrl,
    link_domain: url.host,
    method,
    type,
  };
};
